import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useDateInput, { DateInput } from "@/components/form/date-input";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import useTextInput, { TextInput } from "@/components/form/text-input";

const S05 = (props) => {
    const claimDate = useDateInput({
        name: "sale[claim][claim_date]",
        label: "Når mottok du klage/reklamasjon fra kjøper?",
        ...props,
    })

    const sellersAnswer = useRadioInput({
        name: "sale[claim][sellers_answer]", label: "Har du svart kjøper?",
        className: "flex--grow",
        options: {
            data: [
                { label: "Ja", value: "TRUE" },
                { label: "Nei", value: "FALSE" },
            ],
        },
        ...props,
    })

    const answerDate = useDateInput({
        name: "sale[claim][answer_date]",
        label: "Når svarte du kjøper?",
        className: "flex--grow",
        ...props,
        disabled: props?.disabled || !sellersAnswer.is("TRUE"),
    })

    const sellersOpinion = useRadioInput({
        name: "sale[claim][sellers_opinion]", label: "Er du enig i kjøper sitt krav?",
        className: "mt-7",
        options: {
            data: [
                { label: "Ja", value: "YES" },
                { label: "Nei", value: "NO" },
                { label: "Delvis", value: "PARTIALLY" },
            ],
        },
        ...props,
    })

    const sellersOpinionDescription = useTextInput({
        name: "sale[claim][sellers_opinion_description]",
        label: "Kan du beskrive hvorfor du ikke er enig i kjøpers krav?",
        placeholder: "Skriv her...",
        className: "mt-7",
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om klagen">
            <DateInput {...claimDate.props}/>

            <div className="group--flex gg-3 sm-gg-7 mt-7">
                <RadioInput {...sellersAnswer.props}/>
                <DateInput {...answerDate.props}/>
            </div>

            <RadioInput {...sellersOpinion.props}/>
            { sellersOpinion.isNot("YES") &&
                <TextInput {...sellersOpinionDescription.props}/>
            }
        </Wrapper>
    );
};

export default S05;
